// Page Header Component
// Top navigation header for Lead Detail page

import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MessageSquare, ArrowLeft } from 'lucide-react';

const PageHeader = () => {
  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          <div className="flex items-center gap-2 sm:gap-4">
            <Link to="/dashboard">
              <Button variant="ghost" size="sm" className="text-slate-600 px-2 sm:px-3" data-testid="back-btn">
                <ArrowLeft className="w-4 h-4 sm:mr-2" />
                <span className="hidden sm:inline">Back to Dashboard</span>
              </Button>
            </Link>
          </div>
          <Link to="/dashboard" className="flex items-center gap-2">
            <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-500 rounded-lg flex items-center justify-center">
              <MessageSquare className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            </div>
            <span className="text-lg sm:text-xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
              IntakePal
            </span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default PageHeader;
